<template>
  <div class="home">
    <dashboard msg="Welcome to Your Vue.js App" />
  </div>
</template>

<script>
// @ is an alias to /src
import Dashboard from '@/ui/components/Dashboard.vue'

export default {
  name: 'Home',
  components: {
    Dashboard,
  },
  created() {
    //
  },
}
</script>
